import React from "react";
import Footer from "../Footer";
import Navbar from "../Navbar";
import image1 from "../../assets/image1.jpg";

const PrivacyPolicy: React.FC = () => {
  const policySections = [
    {
      title: "1. Information We Collect",
      list: [
        "Personal Identification: Full Name, Email, Phone Number, Date of Birth, Address, PAN, Aadhaar, Employment Information, Bank Account Details, and Financial Data.",
        "Financial Information: Documents such as Bank Statements, Salary Slips, and Consent for Credit Checks are required for loan applications.",
        "Transactional Information: Details about your loans, repayment schedules, and transaction history are recorded.",
      ],
    },
    {
      title: "2. How We Use Your Information",
      list: [
        "Loan Processing: We assess your loan eligibility, process applications, and manage repayments.",
        "Service Improvement: We enhance our platform based on user feedback and interactions.",
        "Communication: We send notifications and respond to inquiries related to our services.",
        "Compliance: We comply with legal requirements like KYC and AML regulations.",
      ],
    },
    {
      title: "3. Sharing Your Information",
      list: [
        "Authorized Third Parties: We work with Credit Bureaus, Payment Gateways, and Verification Agencies to process and verify your information.",
        "Legal Authorities: We may disclose your information as required by the law, such as for regulatory reporting or fraud investigations.",
        `Parent Company: We may share your data with our parent company, ${import.meta.env.VITE_COMPANY_NBFC}, for loan processing.`,
      ],
    },
    {
      title: "4. Data Security",
      content:
        "We employ encryption, secure servers, and multi-factor authentication to safeguard your data. However, no system is 100% secure, and we encourage users to proceed with caution.",
    },
    {
      title: "5. Cookies and Tracking",
      content:
        "We use cookies and tracking technologies to enhance your browsing experience. You can control cookies through browser settings.",
    },
    {
      title: "6. Your Rights",
      content:
        "You have the right to access, correct, delete, or request portability of your data. You can also opt out of marketing communications at any time.",
    },
    {
      title: "7. Retention of Information",
      content:
        "We retain your information as long as it is necessary for business or legal reasons, and securely delete it when it is no longer needed.",
    },
    {
      title: "8. Third-Party Links",
      content:
        "Our platform may link to third-party websites. We are not responsible for their privacy practices.",
    },
    {
      title: "9. Children’s Privacy",
      content:
        "We do not knowingly collect data from children under 18. If we find any, we will delete it.",
    },
    {
      title: "10. Policy Updates",
      content:
        "We may update this policy periodically. Check this page for any changes.",
    },
    {
      title: "11. Contact Us",
      list: [
        `Email: ${import.meta.env.VITE_COMPANY_EMAIL}`,
        `Phone: ${import.meta.env.VITE_COMPANY_PHONE}`,
        `Address: ${import.meta.env.VITE_COMPANY_ADDRESS}`,
      ],
    },
  ];

  return (
    <div className="min-w-screen bg-[#141237]">
      <div className="flex w-full flex-col items-center justify-center gap-12 px-4 py-16">
        <Navbar />

        {/* Hero Section */}
        <section className="relative text-center text-white py-16 rounded-xl shadow-lg px-6 md:px-12 overflow-hidden w-full max-w-4xl">
          <img
            src={image1}
            alt="Privacy background"
            className="absolute inset-0 w-full h-full object-cover opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#141237]/80 via-[#FF2D55]/20 to-[#141237]/80 rounded-xl"></div>
          <div className="relative z-10">
            <h1 className="text-4xl sm:text-5xl font-bold mb-4 drop-shadow-lg">
              Privacy Policy
            </h1>
            <p className="text-lg sm:text-xl max-w-3xl mx-auto leading-relaxed drop-shadow-md mt-4">
              At <span className="font-semibold">{import.meta.env.VITE_COMPANY_NAME}</span>, a lending
              platform under {import.meta.env.VITE_COMPANY_NBFC}, we prioritize your
              privacy. This policy explains how we collect, use, and protect
              your data.
            </p>
          </div>
        </section>

        {/* Policy Content */}
        <div className="max-w-4xl w-full mx-auto p-8 bg-white rounded-xl shadow-md text-gray-800 space-y-6">
          {policySections.map((section, idx) => (
            <div key={idx} className="space-y-2">
              <h2 className="text-2xl font-semibold text-[#FF2D55]">
                {section.title}
              </h2>
              {section.content && <p>{section.content}</p>}
              {section.list && (
                <ul className="list-disc list-inside ml-4 space-y-1">
                  {section.list.map((li, i) => (
                    <li key={i}>{li}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default PrivacyPolicy;
